import { render } from "./NexusProfile.vue?vue&type=template&id=754ecb24"
import script from "./NexusProfile.vue?vue&type=script&lang=js"
export * from "./NexusProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__